import React, { useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import axios from '../../plugins/axios';

// components
import Header from '../../components/Header/Header';
import Breadcrumbs from '../../components/Breadcrumbs';
import Navbar from '../../components/Navbar/Navbar';

// icons
import newClient from '../../brand/generated/header/newClient.svg';
import getClientsNavigationCount from '../../api/clients/getClientsNavigationCount';

const ClientsNavigation = () => {
  const { id } = useParams();
  const location = useLocation();
  // ÐÐ° ÑÐºÑÐ°Ð½Ðµ ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ° ÑÐµÑÐµÐ· eGov (create-pkb) Ð²ÐºÐ»Ð°Ð´ÐºÐ¸ Ð½Ðµ Ð½ÑÐ¶Ð½Ñ.
  const isPkbCreate = location.pathname.endsWith('/client/create-pkb');
  const [client, setClient] = React.useState({});

  const init = async () => {
    if(!id) return;
    await axios
      .get('/api/crm/clients/getClients', { params: { id: id } })
      .then((res) => {
        setClient(res.data.users[0]);
      })
      .catch((error) => console.log(error));
    await getClientsNavigationCount({ userId: id }).then((res) => {
      setItems([
        { text: 'ÐÑÐ½Ð¾Ð²Ð½ÑÐµ Ð´Ð°Ð½Ð½ÑÐµ', navigate: id ? `/client/${id}/main-data` : '/client/create' },
        { text: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ', navigate: id ? `/client/${id}/documents` : '/client/documents' },
        { text: 'Ð¡Ð´ÐµÐ»ÐºÐ¸', navigate: id ? `/client/${id}/deals` : '/client/deals', count: res.data.deals },
        { text: 'ÐÐ°Ð¿Ð¸ÑÐ¸', navigate: id ? `/client/${id}/records` : '/client/records', count: res.data.services },
      ]);
    });
  };

  React.useEffect(() => {
    if (!id) {
      setItems([{ text: 'ÐÑÐ½Ð¾Ð²Ð½ÑÐµ Ð´Ð°Ð½Ð½ÑÐµ', navigate: id ? `/client/${id}/main-data` : '/client/create' }]);
    } else {
      setItems([
        { text: 'ÐÑÐ½Ð¾Ð²Ð½ÑÐµ Ð´Ð°Ð½Ð½ÑÐµ', navigate: id ? `/client/${id}/main-data` : '/client/create' },
        { text: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ', navigate: id ? `/client/${id}/documents` : '/client/documents' },
        { text: 'Ð¡Ð´ÐµÐ»ÐºÐ¸', navigate: id ? `/client/${id}/deals` : '/client/deals', count: 0 },
        { text: 'ÐÐ°Ð¿Ð¸ÑÐ¸', navigate: id ? `/client/${id}/records` : '/client/records', count: 0 },
      ]);
      init();
    }
  }, []);

  const [items, setItems] = useState([
    { text: 'ÐÑÐ½Ð¾Ð²Ð½ÑÐµ Ð´Ð°Ð½Ð½ÑÐµ', navigate: id ? `/client/${id}/main-data` : '/client/create' },
  ]);

  return (
    <>
      <Header title={id ? `${client.surname} ${client.name} - ID ${client.id}` : 'ÐÐ¾Ð²ÑÐ¹ ÐºÐ»Ð¸ÐµÐ½Ñ'} icon={newClient} />
      <Breadcrumbs
        navigate={'/'}
        link={'ÐÐ»Ð¸ÐµÐ½ÑÑ'}
        currentPage={id ? `${client.surname} ${client.name} - ID ${client.id}` : 'ÐÐ¾Ð²ÑÐ¹ ÐºÐ»Ð¸ÐµÐ½Ñ'}
      />
      {!isPkbCreate && <Navbar items={items} />}
      <Outlet context={[client, setClient]} />
    </>
  );
};

export default ClientsNavigation;
